/**
 * Document state:
  • TO_PAY              ... financial document with some open amount BEFORE due date, parameter dayCount sets how many days before due date (dueDate x sysDate)
  • TO_PAY_DIRECT_DEBIT ... financial document with some open amount BEFORE due date - with paymentType DirectDebit
  • TO_PAY_DEPOSIT      ... financial document with some open amount BEFORE due date and financial document type = deposit (DE)
  • UNPAID              ... financial document with some open amount AFTER due date, parameter dayCount sets how many days after due date (dueDate x sysDate)
  • PAID                ... document is paid == amountTotal – .amountPaid=< 0 (for deposit is also required depositReleaseDate = null)
  • INSTALLMENT         ... for financial document is set installment calendar
  • WITHDRAWAL          ... document was cancelled
  • DEPOSIT_TRANSFERED  ... deposit transferred to overpay
  • CREDIT_TRANSFERED   ... credit transferred to overpay
  • CREDIT_USED         ... credit used to pay other financial document
  • UNDEFINED           ... unknown document state
  • PAYMENT_IN_PROGRESS ... State indicating that the payment is currently being processed.

 */
export type DocumentBalanceStateType = (typeof DocumentBalanceStateType)[keyof typeof DocumentBalanceStateType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentBalanceStateType = {
  TO_PAY: 'TO_PAY',
  TO_PAY_DIRECT_DEBIT: 'TO_PAY_DIRECT_DEBIT',
  TO_PAY_DEPOSIT: 'TO_PAY_DEPOSIT',
  UNPAID: 'UNPAID',
  PAID: 'PAID',
  INSTALLMENT: 'INSTALLMENT',
  WITHDRAWAL: 'WITHDRAWAL',
  DEPOSIT_TRANSFERED: 'DEPOSIT_TRANSFERED',
  CREDIT_TRANSFERED: 'CREDIT_TRANSFERED',
  CREDIT_USED: 'CREDIT_USED',
  UNDEFINED: 'UNDEFINED',
  PAYMENT_IN_PROGRESS: 'PAYMENT_IN_PROGRESS',
} as const;
